import React, { useContext, useState } from 'react'
import { EventMetaContext } from '../SingleEvent'

import BigModal from '../../../../components/Modals/BigModal'
import { Button, Stack, TextField, Typography } from '@mui/material'
import AnDateField from '../../../../components/DateTime/DateField'
import StaffSelector from '../../StaffSelector'
import moment from 'moment'
import API from '../../../../services/API'
import { GlobalContext, UserContext } from '../../../../App'

const ActionPopup = ({ open, onClose }) => {
  const { setEventMeta, eventMeta } = useContext(EventMetaContext)
  const { setToast } = useContext(GlobalContext)
  const { user } = useContext(UserContext)
  const [what, setWhat] = useState('')
  const [how, setHow] = useState('')
  const [when, setWhen] = useState(moment().add(1, 'month'))
  const [personResponsible, setPersonResponsible] = useState(null)

  const handleSubmit = (e) => {
    e.preventDefault()
    API.post('/events/peaaction', {
      event: eventMeta._id,
      what,
      how,
      when,
      personResponsible: personResponsible.userAccount._id,
    }).then((res) => {
      if (res.status === 200) {
        onClose()
        setToast({
          message: 'Action Created',
        })
        setEventMeta((prev) => ({
          ...prev,
          peaactions: [
            ...prev.peaactions,
            {
              event: eventMeta._id,
              completedBy: user,
              what,
              how,
              when,
              personResponsible: personResponsible.userAccount,
            },
          ],
        }))
        setWhat('')
        setHow('')
        setWhen(moment().add(1, 'month'))
        setPersonResponsible(null)
      } else {
        setToast({ severity: 'error', message: 'Unable to add Action.' })
      }
    })
  }

  return (
    <BigModal autoWidth open={open} onClose={onClose}>
      <Stack gap={2} component="form" onSubmit={handleSubmit}>
        <Typography variant="title2" fontSize="1rem">
          Add a Post Event Analysis Action to {eventMeta.title}
        </Typography>
        <TextField
          value={what}
          onChange={(e) => setWhat(e.target.value)}
          label="What?"
          required
        />
        <TextField
          value={how}
          onChange={(e) => setHow(e.target.value)}
          label="How?"
          required
        />
        <AnDateField
          value={when}
          onChange={(newDate) => setWhen(newDate)}
          label="When?"
          required
        />
        <StaffSelector
          value={personResponsible}
          onChange={(e, value) => {
            setPersonResponsible(value)
          }}
          label="By Who?"
          team="Event Planning"
          helperText="Users here are in the 'Event Planning' team"
          required
        />
        <Button type="submit" color="success">
          Submit
        </Button>
      </Stack>
    </BigModal>
  )
}

export default ActionPopup
